import Typography from "@material-ui/core/Typography";
import { FormattedMessage } from "react-intl";
import { PrivacyPolicyLink, SoftwareTermsOfUseLink } from "../common";

export const PakistanPrivacyPolicy = () => {
  return (
    <Typography variant="body1" data-testid="privacyPolicy.pakistan">
      <FormattedMessage
        id="first-sign-in.pakistan.privacyTerms"
        defaultMessage="Elephant must process your personal information in order to set up your professional user account. Your information will be encrypted and stored securely on servers in and outside Pakistan and processed in accordance with Elephant’s {PrivacyPolicyLink}. By using Elephant, you agree to our {SoftwareTermsOfUseLink}."
        values={{
          PrivacyPolicyLink: <PrivacyPolicyLink />,
          SoftwareTermsOfUseLink: <SoftwareTermsOfUseLink />,
        }}
      />
    </Typography>
  );
};
